function NavBar() {
  return (
    <nav>
      <ul className="nav-links">
        <li>
          <a
            href="https://www.dropbox.com/scl/fi/4kgs4pmr129spb9vf5ywp/JESS-CUSHNIE-CV-2.pdf?rlkey=cpsmtul40laxkudlccjnntdun&st=7vmkbavj&dl=0"
            download="JESS CUSHNIE CV.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            resume
          </a>
        </li>
        <li>
          <a href="mailto:jesscushnie@gmail.com">contact</a>
        </li>
      </ul>
    </nav>
  );
}

export default NavBar;
